import baseApi from "../api/baseApi";

const nameChangeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllNameChangeRequests: builder.query({
      query: ({ page = 1, limit = 5 } = {}) => {
        const params = new URLSearchParams({
          page: String(page),
          limit: String(limit),
        });

        return `/namechange/getAllNameChangeRequests?${params.toString()}`;
      },
    }),
    approveOrRejectNameChangeRequest: builder.mutation({
      query: ({ id, isApproved }) => ({
        url: `/namechange/approveOrRejectNameChangeRequest/${id}`,
        method: "PATCH",
        credentials: "include",
        body: { isApproved },
      }),
    }),
  }),
});

export const {
  useGetAllNameChangeRequestsQuery,
  useApproveOrRejectNameChangeRequestMutation,
} = nameChangeApi;
